import Vue from "vue";
const view = Vue.extend({ render: h => h("router-view") });

const classManage = () =>
  import(
    /* webpackChunkName: "apply-class-manage" */ "@/views/teacherApplyEmployment/classManage/index.vue"
  );
// 灰度老师管理
const classManageGray = () =>
  import(
    /* webpackChunkName: "apply-class-manage-gray" */ "@/views/teacherApplyEmployment/classManage/index-gray.vue"
  );
const classManageOpen = () =>
  import(
    /* webpackChunkName: "apply-class-manage-open" */ "@/views/teacherApplyEmployment/classManage/open.vue"
  );
const classManageClose = () =>
  import(
    /* webpackChunkName: "apply-class-manage-close" */ "@/views/teacherApplyEmployment/classManage/close.vue"
  );
const classManageLeave = () =>
  import(
    /* webpackChunkName: "apply-class-manage-leave" */ "@/views/teacherApplyEmployment/classManage/leave.vue"
  );
// 灰度请假
const classManageLeaveGray = () =>
  import(
    /* webpackChunkName: "apply-class-manage-leave-gray" */ "@/views/teacherApplyEmployment/classManage/leave-gray.vue"
  );
const leaveInfo = () =>
  import(
    /* webpackChunkName: "apply-leave-info" */ "@/views/teacherApplyEmployment/leaveInfo/index.vue"
  );
const leaveInfoGray = () =>
  import(
    /* webpackChunkName: "apply-leave-info-gray" */ "@/views/teacherApplyEmployment/leaveInfo-gray/index.vue"
  );
const leaveDetail = () =>
  import(
    /* webpackChunkName: "apply-leave-detail" */ "@/views/teacherApplyEmployment/leaveDetail/index.vue"
  );
const fixedTime = () =>
  import(
    /* webpackChunkName: "apply-fixed-time" */ "@/views/teacherApplyEmployment/fixedTime/index.vue"
  );
// 教管考核时段
const openAssessmentPeriod = () =>
  import(
    /* webpackChunkName: "apply-open-assessment-period" */ "@/views/teacherApplyEmployment/openAssessmentPeriod/index.vue"
  );
// 教管考核时段-无权限
const timeManageNoAuthorize = () =>
  import(
    /* webpackChunkName: "apply-time-manage-no-authorize" */ "@/views/teacherApplyEmployment/openAssessmentPeriod/noAuthorize.vue"
  );
const attendOrRefuse = () =>
  import(
    /* webpackChunkName: "apply-attend-or-refuse" */ "@/views/teacherApplyEmployment/attendOrRefuse/index.vue"
  );
const attendOrRefuseList = () =>
  import(
    /* webpackChunkName: "apply-attend-or-refuse-list" */ "@/views/teacherApplyEmployment/attendOrRefuse/list.vue"
  );
const teacherUserCenter = () =>
  import(
    /* webpackChunkName: "apply-teacher-user-center" */ "@/views/teacherApplyEmployment/userCenter/index.vue"
  );
/**
 * 老固定时段管理
 */
const fixedTimeIndex = () =>
  import(
    /* webpackChunkName: "apply-fixed-time-index" */ "@/views/teacherApplyEmployment/fixedTime/index.vue"
  );
/**
 * 固定时段管理
 */
const fixedTimeManageIndex = () =>
  import(
    /* webpackChunkName: "apply-fixed-time-manage-index" */ "@/views/teacherApplyEmployment/fixedTime/manage/index.vue"
  );
/**
 * 固定时段管理-关闭时段申请
 */
const fixedTimeManageClose = () =>
  import(
    /* webpackChunkName: "apply-fixed-time-manage-close" */ "@/views/teacherApplyEmployment/fixedTime/manage/close.vue"
  );
/**
 * 固定时段管理-关闭时段申请 新页面
 */
const fixedTimeManageCloseTime = () =>
  import(
    /* webpackChunkName: "apply-fixed-time-manage-close" */ "@/views/teacherApplyEmployment/fixedTime/manage/closeTime.vue"
  );
/**
 * 固定时段管理-时段变更记录列表
 */
const fixedTimeRecordList = () =>
  import(
    /* webpackChunkName: "apply-fixed-time-record-list" */ "@/views/teacherApplyEmployment/fixedTime/changeRecord/list.vue"
  );
/**
 * 固定时段管理-时段变更记录详情
 */
const fixedTimeRecordDetail = () =>
  import(
    /* webpackChunkName: "apply-fixed-time-record-detail" */ "@/views/teacherApplyEmployment/fixedTime/changeRecord/detail.vue"
  );
// 非正式老师个人中心
const userCenterNotFormal = () =>
  import(
    /* webpackChunkName: "apply-user-center-not-formal" */ "@/views/teacherApplyEmployment/userCenter/index.vue"
  );
// 功能未开发完成的页面
const pageNotFinished = () =>
  import(
    /* webpackChunkName: "apply-page-not-finished" */ "@/views/teacherApplyEmployment/userCenter/noFinish.vue"
  );
// 专职老师报名页
const teacherRegister = () =>
  import(
    /* webpackChunkName: "apply-teacher-register" */ "@/views/teacherApplyEmployment/teacherRegister/index.vue"
  );

// 专职老师报名审核页
const upgradeTeacher = () =>
  import(
    /* webpackChunkName: "apply-upgrade-teacher" */ "@/views/teacherApplyEmployment/upgradeTeacher/index.vue"
  );

// 专职老师报名审核页
const partTimeTeacher = () =>
  import(
    /* webpackChunkName: "apply-part-time-teacher" */ "@/views/teacherApplyEmployment/fixedTime/partTimeTeacher/index.vue"
  );
// 违规记录
const breakRule = () =>
  import(
    /* webpackChunkName: "apply-break-rule" */ "@/views/teacherApplyEmployment/breakRule/index.vue"
  );
// 违规详情
const breakInfo = () =>
  import(
    /* webpackChunkName: "apply-break-info" */ "@/views/teacherApplyEmployment/breakRule/breakInfo/index.vue"
  );
//固定时段确认
const confirmFixedTime = () =>
  import(
    /* webpackChunkName: "confirm-fixed-time" */ "@/views/teacherApplyEmployment/confirmFixedTime/index.vue"
  );
//等级权益
const growthSystem = () =>
  import(
    /* webpackChunkName: "growth-system" */ "@/views/teacherApplyEmployment/growthSystem/index.vue"
  );
//历史明细
const historyDetail = () =>
  import(
    /* webpackChunkName: "history-detail" */ "@/views/teacherApplyEmployment/growthSystem/historyDetail.vue"
  );
//新固定时段管理
const publicFixedTime = () =>
  import(
    /* webpackChunkName: "public-fixed-time" */ "@/views/teacherApplyEmployment/publicFixedTime/index.vue"
  );
//新关闭固定时段管理
const fixedTimeClose = () =>
  import(
    /*webpackChunkName: "teacherFixed" */ "@/views/teacherApplyEmployment/publicFixedTime/closeTime/index.vue"
  );
//等级权益
const upgradeStrategy = () =>
  import(
    /*webpackChunkName: "upgrade-strategy"*/ "@/views/teacherApplyEmployment/growthSystem/upgradeStrategy.vue"
  );

export default {
  path: "/teacherApplyEmployment",
  name: "teacherApplyEmployment",
  component: view,
  children: [
    {
      name: "register",
      path: "register",
      component: teacherRegister
    },
    {
      name: "upgradeTeacher",
      path: "upgradeTeacher",
      component: upgradeTeacher
    },
    {
      path: "classManage",
      component: view,
      children: [
        {
          path: "",
          component: classManage
        },
        {
          path: "open",
          component: classManageOpen
        },
        {
          path: "close",
          component: classManageClose
        },
        {
          path: "leave",
          component: classManageLeave
        }
      ]
    },
    {
      path: "classManage-gray",
      component: view,
      children: [
        {
          path: "",
          component: classManageGray
        },
        {
          path: "leave",
          component: classManageLeaveGray
        }
      ]
    },
    {
      name: "leaveInfo2",
      path: "leaveInfo",
      component: leaveInfo
    },
    {
      name: "leaveInfoGray",
      path: "leaveInfo-gray",
      meta: {
        keepAlive: true
      },
      component: leaveInfoGray
    },
    {
      name: "leaveDetail2",
      path: "leaveDetail",
      component: leaveDetail
    },
    {
      path: "fixedTime",
      component: view,
      children: [
        {
          name: "fixedTime1Def",
          path: "",
          component: fixedTimeIndex
        },
        {
          name: "partTimeTeacher",
          path: "partTimeTeacher",
          component: partTimeTeacher
        },
        {
          name: "manage",
          path: "manage",
          component: view,
          redirect: "manage/index",
          children: [
            {
              name: "index",
              path: "index",
              component: fixedTimeManageIndex
            },
            {
              name: "close",
              path: "close",
              component: fixedTimeManageClose
            },
            {
              name: "closeTime",
              path: "closeTime",
              component: fixedTimeManageCloseTime
            }
          ]
        },
        {
          name: "record",
          path: "record",
          component: view,
          redirect: "record/list",
          children: [
            {
              name: "list",
              path: "list",
              meta: {
                keepAlive: true
              },
              component: fixedTimeRecordList
            },
            {
              name: "detail",
              path: "detail",
              component: fixedTimeRecordDetail
            }
          ]
        }
      ]
    },
    {
      name: "openAssessmentPeriod",
      path: "openAssessmentPeriod",
      component: openAssessmentPeriod
    },
    {
      name: "timeManageNoAuthorize",
      path: "timeManageNoAuthorize",
      component: timeManageNoAuthorize
    },
    {
      name: "userCenter",
      path: "userCenter",
      component: teacherUserCenter
    },
    {
      name: "userCenterNotFormal",
      path: "userCenterNotFormal",
      component: userCenterNotFormal
    },
    {
      path: "attendOrRefuse",
      component: view,
      children: [
        {
          name: "attendOrRefuse",
          path: "",
          component: attendOrRefuse
        },
        {
          name: "list2",
          path: "list",
          component: attendOrRefuseList
        }
      ]
    },
    {
      name: "pageNotFinished",
      path: "pageNotFinished",
      component: pageNotFinished
    },
    {
      path: "breakRule",
      component: view,
      children: [
        {
          path: "",
          name: "breakRule",
          component: breakRule
        },
        {
          name: "breakInfo",
          path: "breakInfo",
          component: breakInfo
        }
      ]
    },
    {
      name: "confirmFixedTime",
      path: "confirmFixedTime",
      component: confirmFixedTime
    },
    {
      name: "growthSystem",
      path: "growthSystem",
      component: growthSystem
    },
    {
      path: "historyDetail",
      name: "historyDetail",
      component: historyDetail
    },
    {
      path: "publicFixedTime",
      component: view,
      children: [
        {
          path: "",
          name: "publicFixedTime",
          component: publicFixedTime
        },
        {
          name: "closeTime2",
          path: "closeTime",
          component: fixedTimeClose
        }
      ]
    },
    {
      path: "upgradeStrategy",
      name: "upgradeStrategy",
      component: upgradeStrategy
    }
  ]
};
